import React, { Component } from "react";
import intl from "react-intl-universal";
import {
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Button
} from "react-bootstrap";
import LoaderButton from "./LoaderButton";
import DivsPattern from "./skylineDesignPattern";
import "./account.css"
import ModalDialog from "./Modal";

class UserPrivacyPreferences extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      failedMessage: "",
      isChecked : true,
      radioButtonValue: "Subscribe",
      showConfirmationModal:false,
      commentMessage:"",
      targetEmail: {"groups":["Licensing"]},
      isLoading: false,
      unsubscribeValue: 0,
    };
  }

  componentDidMount() {
    this.GetUserPrivacyPreferences();
  }

  GetUserPrivacyPreferences = () => {
    this.setState({ isLoading: true });

    fetch(process.env.REACT_APP_API_URL + "GetUserPrivacyPreferences", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: ""
    })
      .then(res => res.json())
      .then(result => {        
        if (result.Result == "success") {
          if(result.Unsubscribe == false){
            this.setState({ isChecked: true, unsubscribeValue: 0});
          } else {
            this.setState({ isChecked: false, unsubscribeValue: 1 });
          }
        } else {
          this.setState({ failedMessage: intl.get("General_Failure") });
        }
      })
      .catch(error => {
        console.error(error);
        this.props.handleServerError(true);
        this.setState(
          {             
            failedMessage: intl.get("General_Failure") 
          }
        );
      })
      .then(()=>{
        this.setState({ isLoading: false });
      });
  }

  validateForm() {
    return (
      this.state.currentPassword.length > 0 &&
      this.state.newPassword.length > 0 &&
      this.state.confirmNewPassword.length > 0 &&
      this.state.newPassword === this.state.confirmNewPassword
    );
  }

   handleRadioButtonValue = (value) => {
    if (value == "Subscribe"){
      this.setState(
        {
          radioButtonValue: value, 
          isChecked: true,
          unsubscribeValue: 0
        }
      );
    }
    else{
      this.setState(
        {
          radioButtonValue:value,
          isChecked:false,
          unsubscribeValue: 1
        }
      );
    }
  };

  cancelOnClick = () => {
    return false;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  handleConfirmationModalClose = () =>{
    this.setState({ showConfirmationModal: false });
  };  

  handleDialog =(event) =>{
    event.preventDefault();
    this.setState({showConfirmationModal:true});
  }

  handleSubmit = event => {
    event.preventDefault();

    this.setState({ isLoading: true });

    fetch(process.env.REACT_APP_API_URL + "UpdateUserPrivacyPreferences", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        preference: this.state.radioButtonValue,
        unsubscribeValue: this.state.unsubscribeValue,
        comment:this.state.commentMessage,
        email: this.props.userName,
        targetEmail: this.state.targetEmail
      })
    })
      .then(res => res.json())
      .then(result => {
        this.setState({ showConfirmationModal: false });
        this.setState({ isLoading: false });
        if (result.Result == "success") {
          if (this.state.radioButtonValue !== "Delete"){
            return this.props.history.push("/account");
          }
          else{
            fetch(process.env.REACT_APP_API_URL + "logout", {
              method: "POST",
              credentials: "include",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({})
            })
            .then(res => res.json())
            .then(result => {
              if (result.Result === "Success") {
                this.props.userHasAuthenticated(false, undefined);
              } else{
                this.setState({ failedMessage: 'failed to logout user' });
              }
            })
          }
        } else {
          this.setState({ failedMessage: result.Message });
        }
      })
      .catch(error => {
        console.error(error);
        this.props.handleServerError(true);
        this.setState(
          { 
            showConfirmationModal: false, 
            isLoading: false, 
            failedMessage: intl.get("General_Failure") }
        );
      });
  };

  render() {
    return (    
      <DivsPattern className={this.state.isLoading ? "privacyHide" : ""} headerText={intl.get("User_Privacy_Preferences_Title")}>
        <form className="form-signin">
          <FormGroup controlId="DeleteUser" className="form-label-group">
            <input id="resubscribeCheck" className="privacyRadio" name="DeleteUser" type="radio" data-indeterminate="false" value="Subscribe"
              onChange={(event) => { this.handleRadioButtonValue(event.target.value) }}
              checked={this.state.isChecked == true} onClick={this.cancelOnClick}></input>
            <label>{intl.get("Resubscribe_to_newsletter_and_marketing_updates")}</label>
          </FormGroup>
          <FormGroup controlId="DeleteUser" className="form-label-group">
            <input id="unsubscribeCheck" className="privacyRadio" name="DeleteUser" type="radio" data-indeterminate="false" value="Unsubscribe"
              onChange={(event) => { this.handleRadioButtonValue(event.target.value) }}
              checked={this.state.isChecked == false} onClick={this.cancelOnClick}></input>
            <label>{intl.get("Unsubscribe_from_newsletter_and_marketing_updates")}</label>
          </FormGroup>
          <FormGroup controlId="DeleteUser" className="form-label-group">
            <label className="privacyDeleteCommentLabel">Comment:</label>
            <textarea className="privacyDeleteCommentTextarea" placeholder="(optional)" value={this.state.commentMessage} onChange={(event) => { this.setState({ commentMessage: event.target.value }); }}>
            </textarea>
          </FormGroup>
          <LoaderButton
            block
            onClick={this.handleDialog}
            className="btn btn-lg btn-primary btn-block btn-login text-uppercase font-weight-bold mb-2 privacyUpdateButton"
            type="submit"
            isLoading={this.state.isLoading}
            text={intl.get("User_Privacy_Preferences_Button")}
            loadingText={intl.get("Update_Privacy_Loading")}
          />
          <ModalDialog
            show={this.state.showConfirmationModal}
            className={this.state.radioButtonValue == "Subscribe" ? "" : "DeleteUser"}
            handleClose={this.handleConfirmationModalClose}
            title={intl.get("Privacy_Modal_Title")}
            message={this.state.radioButtonValue == "Subscribe" ? intl.get("Subscribe_Alert") : intl.get("UnSubscribe_Alert")}
            handleSubmitClose={this.handleSubmit}
            handleButtonName={intl.get("Privacy_Update_Button")}
            primaryButtonId={"ApproveButtonId"}
            secondaryButtonId={"declineButtonId"}
            handleButtonClose={intl.get("Privacy_Close_Button")}
            modalClassName={"deleteUserModal"}
            modelSizeWindow="lg"
            modalHeaderClass="modalHeader"
          />
          <span style={{ color: "red" }}>{this.state.failedMessage}</span>
        </form>
      </DivsPattern>
    );
  }
}

export default UserPrivacyPreferences;
